(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer-bands"] && !Shopify.designMode) return;
  try {
    

  const baseURL = "https://statement.gemist.co/";
  const gemistOrigin = new URL(baseURL).origin;
  const LOG = "[gemist:gemist-designer]";

  var contactFormBridgeLastAt = 0;
  const contactFormBridgeId = "gemist-designer";

  function gemistFormatPropertyLabel(key) {
    var spaced = key.replace(/_/g, " ").replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    return spaced.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function isDesignerIframeFullscreen(iframe) {
    return (
      document.fullscreenElement === iframe ||
      document.webkitFullscreenElement === iframe ||
      document.mozFullScreenElement === iframe ||
      document.msFullscreenElement === iframe
    );
  }

  function postFullscreenStateToDesignerIframe() {
    var iframe = document.getElementById("designer-iframe");
    if (!iframe || !iframe.contentWindow) {
      return;
    }
    var active = isDesignerIframeFullscreen(iframe);
    var payload = JSON.stringify({type: "fullscreenstate", active: active});
    iframe.contentWindow.postMessage(payload, gemistOrigin);
  }

  function gemistNormalizeCartAddItems(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (data.items && Array.isArray(data.items)) return data.items;
    if (data.variant_id !== undefined) return [data];
    return [];
  }

  function gemistProductUrlFromAddResponse(addPayload, variantIdStr) {
    var items = gemistNormalizeCartAddItems(addPayload);
    var i;
    for (i = 0; i < items.length; i++) {
      if (
        items[i].variant_id !== undefined &&
        String(items[i].variant_id) === variantIdStr &&
        items[i].url
      ) {
        return items[i].url;
      }
    }
    return "";
  }

  function gemistSecureImageUrl(url) {
    if (!url || typeof url !== "string") return "";
    var u = url.trim();
    if (u.indexOf("//") === 0) return "https:" + u;
    return u;
  }

  function gemistPatchCartLineThumbnail(variantIdStr, imageUrl, productUrl) {
    if (!variantIdStr || !imageUrl) return false;
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return false;
    var row = drawer.querySelector('.cart__item[data-key^="' + variantIdStr + ':"]');
    if (!row) return false;
    var cell = row.querySelector(".cart__image");
    if (!cell) return false;
    if (cell.querySelector("[data-gemist-thumb]")) return true;

    var href = productUrl || "#";
    var secureImg = gemistSecureImageUrl(imageUrl);
    if (!secureImg) return false;

    var a = document.createElement("a");
    a.href = href;
    a.className = "image-wrap loaded";
    a.setAttribute("data-gemist-thumb", "1");

    var imageEl = document.createElement("image-element");
    imageEl.setAttribute("data-aos", "image-fade-in");
    imageEl.setAttribute("data-aos-offset", "150");
    imageEl.className = "aos-init aos-animate";

    var img = document.createElement("img");
    img.src = secureImg;
    img.setAttribute("data-gemist-patch", "true");
    img.alt = "";
    img.width = 540;
    img.loading = "lazy";
    img.className = " image-element";
    img.setAttribute("sizes", "100px");
    img.setAttribute(
      "srcset",
      secureImg + " 180w, " + secureImg + " 360w, " + secureImg + " 540w"
    );

    imageEl.appendChild(img);
    a.appendChild(imageEl);
    cell.innerHTML = "";
    cell.appendChild(a);
    return true;
  }

  function gemistScheduleCartThumbnailPatch(variantIdStr, imageUrl, productUrl) {
    if (!variantIdStr || !imageUrl) return;
    var attempts = 0;
    var maxAttempts = 50;
    function tick() {
      if (gemistPatchCartLineThumbnail(variantIdStr, imageUrl, productUrl)) return;
      attempts++;
      if (attempts < maxAttempts) setTimeout(tick, 60);
    }
    tick();
  }

// Impulse (and similar) themes: CartDrawer listens for this after AjaxProduct add; builds drawer HTML and opens.
// Match theme.js: skip the drawer chain on the full cart page template, where the theme uses the page cart.
  function dispatchImpulseAjaxProductAdded(addJsResponse) {
    if (document.body && document.body.classList && document.body.classList.contains("template-cart")) {
      return;
    }
    var ev = new CustomEvent("ajaxProduct:added", {
      detail: {
        product: addJsResponse,
        addToCartBtn: null
      },
      bubbles: true
    });
    var form = document.getElementById("CartDrawerForm");
    if (form) {
      form.dispatchEvent(ev);
    } else {
      document.dispatchEvent(ev);
    }
  }

  window.onload = function() {

    const iframeParams = new URLSearchParams(window.location.search);

    if (!iframeParams.get('shape')) {
      iframeParams.set('shape', 'Asscher');
    }

    var iframeUrl = baseURL + "designer/bands?" + iframeParams.toString();

    var iframe = document.getElementById("designer-iframe");

    iframe.src = iframeUrl;
  };

  window.addEventListener("message", function(event) {

    const designerIframe = document.getElementById("designer-iframe");
    if (event.origin !== gemistOrigin) {
      return;
    }

    if (event.data) {
      try {
        const message = typeof event.data === 'string'
          ? JSON.parse(event.data)
          : event.data;
        switch (message.type) {
          case "requestParentWindowHref":
            if (designerIframe && designerIframe.contentWindow) {
              designerIframe.contentWindow.postMessage(window.location.href, gemistOrigin);
            }
            break;
          case "buy":

// Ring variant id: prefer the one we just created (message.ring.variantId), else existing product from Shopify
            var rawRingId = (message.ring && message.ring.variantId !== undefined)
              ? message.ring.variantId
              : (message.product && message.product.Shopify && message.product.Shopify.productVariant);

            var id;
            if (rawRingId === undefined || rawRingId === null) {
              id = undefined;
            } else if (typeof rawRingId === "number") {
              id = String(rawRingId);
            } else if (typeof rawRingId === "string" && rawRingId.indexOf("/") !== -1) {
              id = rawRingId.split("/").slice(-1)[0];
            } else {
              id = rawRingId;
            }
            var size = message.size;

            const ringItems = [];
            let product = {
              id: id,
              quantity: 1,
              properties: {
                Size: size,
                _gemist__ring: true
              }
            };
            var ring = message.ring || {};
            Object.keys(ring).forEach(function (key) {
              if (key === "variantId" || key === "sku") return;
              var value = ring[key];
              if (value === undefined || value === null || value === "" || typeof value === "object") return;
              product.properties[gemistFormatPropertyLabel(key)] = value;
            });
            ringItems.push(product);

            cart = window.cart || document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            if (! id) {
              designerIframe.contentWindow.postMessage({type: 'cart', status: 'error', message: 'No variant id'}, '*');
            } else {
              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(
                  {items: ringItems}
                )
              }).then((response) => {
                return response.json().then(function(data) {
                  return {ok: response.ok, status: response.status, data: data};
                });
              }).then(function(result) {
                if (! result.ok) {
                  var errMsg = (result.data && result.data.description)
                    ? result.data.description
                    : (result.data && result.data.message)
                      ? result.data.message
                      : 'Add to cart failed';
                  designerIframe.contentWindow.postMessage({type: 'cart', status: 'error', message: errMsg}, '*');
                  return;
                }


                  window.location.href = window.Shopify.routes.root + "cart";

                // var gemistThumbUrl = typeof message.image === "string" ? message.image : "";
                // var gemistLineProductUrl = gemistProductUrlFromAddResponse(result.data, id);
                // gemistScheduleCartThumbnailPatch(id, gemistThumbUrl, gemistLineProductUrl);

                if (message.diamond && message.diamond.variantId !== undefined) {
                  var diamondVariantId = message.diamond.variantId;
                  if (typeof diamondVariantId === "number") 
                    diamondVariantId = String(diamondVariantId);
                   else if (typeof diamondVariantId === "string" && diamondVariantId.indexOf("/") !== -1) {
                    diamondVariantId = diamondVariantId.split("/").slice(-1)[0];
                  }
                  let diamond = {
                    id: diamondVariantId,
                    quantity: 1
                  };

                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(
                      {items: [diamond]}
                    )
                  }).then((res) => res.json().then((d) => ({ok: res.ok, data: d}))).then(function(diamondResult) {
                    if (cart && typeof cart.getCart === "function") {
                      cart.getCart();
                    }
                    var ev = new Event("cart:refresh");
                    document.dispatchEvent(ev);
                    setTimeout(function() {
                      document.dispatchEvent(ev);
                    }, 3000);
                    if (diamondResult.ok) {
                      dispatchImpulseAjaxProductAdded(diamondResult.data);
                      designerIframe.contentWindow.postMessage({type: 'cart', status: 'added'}, '*');
                    } else {
                      var msg = (diamondResult.data && diamondResult.data.description)
                        ? diamondResult.data.description
                        : (diamondResult.data && diamondResult.data.message)
                          ? diamondResult.data.message
                          : 'Diamond add failed';
                      designerIframe.contentWindow.postMessage({type: 'cart', status: 'error', message: msg}, '*');
                    }
                  }).catch((error) => {
                    console.error("Error adding the diamond:", error);
                    designerIframe.contentWindow.postMessage({type: 'cart', status: 'error', message: String(error)}, '*');
                  });
                } else {
                  dispatchImpulseAjaxProductAdded(result.data);
                  designerIframe.contentWindow.postMessage({type: 'cart', status: 'added'}, '*');
                }
              }).catch((error) => {
                console.error("Error adding the ring:", error);
                designerIframe.contentWindow.postMessage({type: 'cart', status: 'error', message: String(error)}, '*');
              });
            }

            break;
          case 'favorite':
            var {
              id
            } = message.product;

            fetch(baseURL + 'api/products/' + id + '/shmetadata').then(response => response.json()).then(data => {
              var {
                productId,
                handle
              } = data;

// create element to save
              var elementToSave = document.createElement('div');
              elementToSave.dataset.id = productId.split('/').slice(-1)[0];
              elementToSave.dataset.handle = handle;

// use the saveWishlist function that we made available from theme.js
              saveWishlist($(elementToSave));
            }).catch((error) => {
              console.error('Error:', error);
            });
            break;
          case 'updateParams':

// Get the parameter names from the message
            var paramNames = message.paramNames;
            var currentURL = new URL(window.location.href);

// Loop through the parameter names
            paramNames.forEach(function(paramName) {

// Retrieve the corresponding value from the message
              var paramValue = message[paramName];

// Mirror the designer exactly: a part the designer no longer reports has been deselected, so
// drop it instead of leaving the old value behind. Choosing a different origin clears
// stone_quality, and a set-only sync kept the previous origin's quality here — an impossible
// pair that the PDF link would embed and a reload would seed back in.
              if (paramValue !== undefined) {
                currentURL.searchParams.set(paramName, paramValue);
              } else {
                currentURL.searchParams.delete(paramName);
              }
            });

// Replace the parent URL with the modified URL
            window.history.replaceState({}, "", currentURL.toString());
            break;
          case 'download':
            const downloadHref = message.downloadHref;


            if (downloadHref) {
              window.open(downloadHref, "_blank");
            }
            break;
          case 'copywindowlocation':

// Get the current window location
            var windowLocation = window.location.href;

// Use the Clipboard API to copy the window location to the clipboard
            navigator
              .clipboard
              .writeText(windowLocation)
              .then(function() {
                console.log("Window location copied to clipboard successfully");
              })
              .catch(function(error) {
                console.error("Failed to copy window location to clipboard:", error);
              });
            break;
          case 'sendemail':
            let {emailContent, subject, recipient} = message;
            const currentPageLink = window.location.href;
            emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);

            const mailtoLink = `mailto:${recipient}?subject=${
              encodeURIComponent(subject)
            }&body=${
              encodeURIComponent(emailContent)
            }`;

            if (mailtoLink) {
              window.open(mailtoLink, "_blank");
            }
            break;
          case "contact":
            {
              var mname = message.name != null
                ? String(message.name)
                : "";
              var memail = message.email != null
                ? String(message.email)
                : "";
              var mphone = message.phone != null
                ? String(message.phone)
                : "";
              var mbody = message.message != null
                ? String(message.message)
                : "";
              console.info(LOG, "contact message (lengths only)", {
                from: event.origin,
                nameLen: mname.length,
                emailLen: memail.length,
                phoneLen: mphone.length,
                messageLen: mbody.length
              });
              if (Date.now() - contactFormBridgeLastAt < 2000) {
                console.warn(LOG, "contact submit ignored (debounce 2s)");
                break;
              }
              contactFormBridgeLastAt = Date.now();
              var contactForm = document.getElementById("contact-iframe-bridge-" + contactFormBridgeId);
              if (! contactForm) {
                console.error(LOG, "contact form not in DOM: #" + "contact-iframe-bridge-" + contactFormBridgeId);
                break;
              }
              var elName = document.getElementById("ContactFormName-" + contactFormBridgeId);
              var elEmail = document.getElementById("ContactFormEmail-" + contactFormBridgeId);
              var elPhone = document.getElementById("ContactFormPhone-" + contactFormBridgeId);
              var elMessage = document.getElementById("ContactFormMessage-" + contactFormBridgeId);
              if (elName) 
                elName.value = mname;
              


              if (elEmail) 
                elEmail.value = memail;
              


              if (elPhone) 
                elPhone.value = mphone;
              


              if (elMessage) 
                elMessage.value = mbody;
              


              console.info(LOG, "requestSubmit on native contact form", {formId: contactForm.id});
              contactForm.requestSubmit();
              break;
            }
          case "requestfullscreen":
            (function () {
              var el = designerIframe;
              if (!el) {
                return;
              }
              var p = null;
              if (el.requestFullscreen) {
                p = el.requestFullscreen();
              } else if (el.webkitRequestFullscreen) {
                el.webkitRequestFullscreen();
              }
              if (p && typeof p.then === "function") {
                p.then(postFullscreenStateToDesignerIframe).catch(function () {});
              }
            })();
            break;
          case "exitfullscreen":
            (function () {
              var p = null;
              if (document.exitFullscreen) {
                p = document.exitFullscreen();
              } else if (document.webkitExitFullscreen) {
                p = document.webkitExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                p = document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                p = document.msExitFullscreen();
              }
              if (p && typeof p.then === "function") {
                p.then(postFullscreenStateToDesignerIframe).catch(function () {});
              }
            })();
            break;
          default:
            break;
        }
      } catch (e) {
        console.error(LOG, "message handler error", e);
      }
    }
  }, false);

  document.addEventListener("fullscreenchange", postFullscreenStateToDesignerIframe, false);
  document.addEventListener("webkitfullscreenchange", postFullscreenStateToDesignerIframe, false);
  document.addEventListener("mozfullscreenchange", postFullscreenStateToDesignerIframe, false);
  document.addEventListener("MSFullscreenChange", postFullscreenStateToDesignerIframe, false);


// This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height,
// then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function() {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(".designer-iframe-container");
    const designerIFrameElement = document.querySelector("#designer-iframe");

    const selectorsToObserve = ["#shopify-section-top-bar", "#shopify-section-header-bottom"];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 40);

      if (designerIFrameContainerElement !== null && designerIFrameElement !== null && totalHeight) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;

        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });


  } catch(e) { console.error(e); }
})();
})();
